import { render, staticRenderFns } from "./TaskOnTargetDetail.vue?vue&type=template&id=a7605160&scoped=true&"
import script from "./TaskOnTargetDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TaskOnTargetDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TaskOnTargetDetail.vue?vue&type=style&index=0&id=a7605160&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7605160",
  null
  
)

export default component.exports